"use client";

import React from "react";
import { Clock } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const hoursData = [{
  day: "Monday",
  time: "7:00 AM - 5:00 PM"
}, {
  day: "Tuesday",
  time: "7:00 AM - 5:00 PM"
}, {
  day: "Wednesday",
  time: "7:00 AM - 5:00 PM"
}, {
  day: "Thursday",
  time: "7:00 AM - 5:00 PM"
}, {
  day: "Friday",
  time: "7:00 AM - 5:00 PM"
}, {
  day: "Saturday",
  time: "7:00 AM - 1:00 PM"
}, {
  day: "Sunday",
  time: "Closed"
}];
export default function OpeningHours() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="openinghours" className="bg-[#0A0C10] py-24 md:py-32">
      <div className="container mx-auto px-4">
        <div ref={ref} className={`max-w-xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="text-center mb-12 md:mb-16">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-emerald-500/10 mb-6">
              <Clock className="w-8 h-8 text-emerald-400" />
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-sans text-white tracking-tight mb-4">
              Opening Hours
            </h2>
            <p className="text-zinc-400 text-base md:text-lg">
              Coastal Prestige Mowing & Maintenance
            </p>
          </div>

          <div className="flex flex-col">
            <Separator className="bg-white/10" />
            {hoursData.map((item, i) => <div key={item.day} data-index={i} className="group">
                <div className="flex justify-between items-center py-5 md:py-6 px-2 transition-colors hover:bg-white/5">
                  <span className="text-white font-medium text-base md:text-lg tracking-wide">
                    {item.day}
                  </span>
                  <span className="text-zinc-400 text-sm md:text-base font-medium">
                    {item.time}
                  </span>
                </div>
                <Separator className="bg-white/10 group-hover:bg-white/20 transition-colors" />
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}